import React from 'react';
import { BringzzText } from "@bringzz/components";
import DefaultProductImage from 'assets/DefaultProductImage.png';

const OrderTab = ({ orders, isAllCategory, onItemClick }) => {
    const getOrderStatusText = (status) => {
        switch(status) {
            case 0: return 'Open';
            case 1: return 'Matching Pharmacy';
            case 2: return 'Pharmacy Matched';
            case 3: return 'Being Prepared';
            case 4: return 'Prepared';
            case 5: return 'Shopper Matched';
            case 6: return 'Shopper Arrived';
            case 7: return 'Shopper Identified';
            case 8: return 'At Pharmacy';
            case 9: return 'Pharmacy Confirmed';
            case 10: return 'Order Confirmed';
            case 11: return 'Shopper Confirmed';
            case 12: return 'Arriving with Package';
            case 13: return 'Ready for Pickup';
            case 14: return 'Package Confirmed';
            case 15: return 'Completed';
            case 16: return 'Cancelled';
            case 17: return 'Error';
            default: return 'Unknown';
        }
    };

    const getOrderStatusColor = (status) => {
        switch(status) {
            case 0: return 'bg-blue-100 text-blue-800';
            case 1: case 2: case 5: return 'bg-yellow-100 text-yellow-800';
            case 3: case 4: case 6: case 7: case 8: case 9: case 10: case 11: case 12: case 13: case 14: return 'bg-purple-100 text-purple-800';
            case 15: return 'bg-green-100 text-green-800';
            case 16: case 17: return 'bg-red-100 text-red-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    };

    const renderOrderItem = (order, index, section) => {
        if (isAllCategory) {
            return (
                <div key={`${section}-${order.id}-${index}`} className='flex items-center border-b py-2 cursor-pointer' onClick={() => onItemClick(order, 'order')}>
                    <BringzzText tag='h4'>{order.productName}</BringzzText>
                </div>
            );
        }
        
        return (
            <div key={`${section}-${order.id}-${index}`} className='flex items-center border-b py-3 cursor-pointer' onClick={() => onItemClick(order, 'order')}>
                {order.productImage ? (
                    <img src={order.productImage} className='w-12 h-12 rounded mr-3 object-cover' alt={order.productName} />
                ) : (
                    <img src={DefaultProductImage} className='w-10 h-10 mr-3 rounded opacity-50' alt='No image' />
                )}
                <div className='flex flex-col flex-grow'>
                    <BringzzText tag='h4' className='font-medium'>{order.productName}</BringzzText>
                    <BringzzText tag='h5' className='text-gray-600'>{new Date(order.orderDate).toLocaleDateString()}</BringzzText>
                    {order.price && <BringzzText tag='h5' className='text-magic-lilac'>€{order.price}</BringzzText>}
                </div>
                <span className={`px-2 py-1 rounded-full text-xs ${getOrderStatusColor(order.orderStatus)}`}>
                    {getOrderStatusText(order.orderStatus)}
                </span>
            </div>
        );
    };

    return { renderOrderItem };
};

export default OrderTab;